import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from './services/api';
import { json } from 'stream/consumers';
import { Employee } from './types';

interface AuthContextType {
  token: Employee | null;
  login: (employee_code: string, password: string) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<Employee | null>(() => {
    const val = localStorage.getItem('token');
    if (val) {
      const token = JSON.parse(val) as Employee;

      return token;
    }
    else {
      return null;
    }
  });

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', JSON.stringify(token));
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  const login = async (employee_code: string, password: string) => {
    const res = await apiLogin(employee_code, password);
    if (res.designation?.user_type !== 'SUPER_ADMIN' && res.designation?.user_type !== 'ADMIN') {
      throw new Error('Access denied: Only SUPER_ADMIN or ADMIN can login.');
    }
    setToken(res);
  };

  const logout = () => {
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
} 